import React from 'react';

const JoinDirectoryPage = () => {
  return (
    <div className="lawyer-page">
      <section className="membership-section">
        <div className="container">
          <div className="section-header">
            <h1 className="section-title">Únete al Directorio Profesional de GesOps</h1>
            <p className="section-description">
              Conecta tu empresa con miles de usuarios en Estados Unidos buscando servicios confiables.
            </p>
          </div>

          <div className="about-content" style={{ marginTop: 24 }}>
            <div className="about-description">
              <p>
                GesOps es un directorio nacional que reúne empresas y profesionales verificados en distintas áreas de servicio. Si deseas aumentar tu
                visibilidad y llegar a más personas, crea tu perfil y forma parte de nuestra red profesional.
              </p>

              <div className="join-benefits">
                <h3>Beneficios de Unirte al Directorio GesOps</h3>
                <ol className="join-benefits-list">
                  <li>
                    <strong>Presencia en un directorio verificado</strong>
                    <p>
                      Tu empresa aparecerá en un entorno seguro, donde todos los perfiles son validados antes de publicarse, lo que genera confianza entre
                      los usuarios.
                    </p>
                  </li>
                  <li>
                    <strong>Posicionamiento de marca a nivel nacional</strong>
                    <p>
                      Tu información estará disponible para usuarios en cualquier estado del país. GesOps facilita que más personas encuentren tu servicio
                      de manera rápida, clara y directa.
                    </p>
                  </li>
                  <li>
                    <strong>Publicidad en los canales oficiales de GesOps</strong>
                    <p>
                      GesOps realiza publicaciones periódicas destacando a las compañías y profesionales registrados, etiquetando sus propias marcas y redirigiendo a
                      los usuarios a validar la información dentro del directorio.
                    </p>
                    <p>Esto te ayuda a:</p>
                    <ul>
                      <li>Aumenta el alcance visual de tu servicio profesional o compañía</li>
                      <li>Atraer nuevos clientes</li>
                      <li>Fortalecer tu identidad profesional</li>
                      <li>Ganar reconocimiento dentro de tu sector</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Contacto directo con los clientes</strong>
                    <p>
                      Los usuarios pueden comunicarse contigo sin intermediarios, sin comisiones y sin complicaciones. GesOps no maneja pagos ni
                      honorarios entre clientes y profesionales.
                    </p>
                  </li>
                  <li>
                    <strong>Perfil profesional completo (Plan Premium)</strong>
                    <p>Incluye:</p>
                    <ul>
                      <li>Logo</li>
                      <li>Biografía</li>
                      <li>Fotos</li>
                      <li>Categorías</li>
                      <li>Estados donde ofreces servicio</li>
                      <li>WhatsApp</li>
                      <li>Redes sociales</li>
                      <li>Botón de contacto</li>
                      <li>Sello verificado</li>
                      <li>Tarjeta destacada según tu plan</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Mayor credibilidad y transparencia</strong>
                    <p>El sello “Verificado por GesOps” ayuda a demostrar que tu empresa:</p>
                    <ul>
                      <li>Existe realmente</li>
                      <li>Está legalmente constituida</li>
                      <li>Cuenta con datos comprobados</li>
                      <li>Ha sido validada por nuestro equipo</li>
                    </ul>
                    <p>Esto aumenta tu reputación frente al cliente.</p>
                  </li>
                  <li>
                    <strong>Posibilidad de aparecer en búsquedas por categoría y estado</strong>
                    <p>Tu empresa podrá ser encontrada fácilmente mediante:</p>
                    <ul>
                      <li>Mapa interactivo</li>
                      <li>Búsqueda por estado</li>
                      <li>Búsqueda por categoría</li>
                      <li>Listados destacados</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Oportunidad de atraer nuevos clientes orgánicamente</strong>
                    <p>
                      Los usuarios que visitan GesOps buscan servicios reales y confiables. Al estar en el directorio, tu empresa tiene la oportunidad
                      de captar clientes interesados directamente en tu sector.
                    </p>
                  </li>
                </ol>
              </div>

              <div className="join-form">
                <div className="membership-cta join-form-cta" style={{ marginTop: 24 }}>
                  <div className="cta-content">
                    <h3 className="cta-title">Formulario de Registro</h3>
                    <div className="cta-buttons">
                      <button className="btn btn-primary" type="button" disabled>
                        Ir al formulario seguro (próximamente)
                      </button>
                    </div>
                    <p className="section-description" style={{ marginTop: 12 }}>
                      Al hacer clic en este botón serás redirigido a un formulario seguro, donde podrás dejarnos tus datos para que nuestro equipo se
                      comunique contigo, te explique los planes disponibles y complete el proceso de registro en el directorio GesOps.
                    </p>
                    <p className="section-description" style={{ marginTop: 12 }}>
                      Tu información será utilizada únicamente para contactarte y brindarte detalles sobre tu inscripción como empresa o profesional dentro
                      de la plataforma.
                    </p>
                  </div>
                </div>
              </div>

              <div className="join-disclaimer">
                <div className="join-disclaimer-note">
                  <p>
                    <strong>Disclaimer:</strong> GesOps LLC no garantiza leads ni un número específico de clientes. Nuestro servicio consiste en posicionar la marca
                    del profesional o empresa dentro de nuestro directorio, brindar visibilidad, exposición y presencia digital para que los usuarios puedan
                    encontrar sus servicios y contactarlos directamente.
                  </p>
                  <p>El alcance de cada perfil depende de factores externos como:</p>
                  <ul>
                    <li>La información suministrada por la empresa</li>
                    <li>La calidad del material proporcionado (fotos, videos, textos, logotipos)</li>
                    <li>La claridad de los datos de contacto</li>
                    <li>La disponibilidad de la empresa para responder a los usuarios</li>
                    <li>La categoría del servicio y la demanda de cada estado</li>
                  </ul>
                  <p>
                    Nuestros diseñadores y equipo de contenido podrán elaborar piezas profesionales únicamente con el material que la empresa facilite. La falta
                    de fotos, videos o información puede limitar el alcance o la presentación visual del perfil dentro del directorio GesOps.
                  </p>
                  <p>
                    GesOps no maneja intermediación de clientes, no capta honorarios, no participa en pagos entre clientes y profesionales y no realiza promesas de
                    resultados comerciales. Nuestro enfoque es incrementar la visibilidad, ofrecer un espacio verificado y facilitar que más personas conozcan su marca y
                    puedan contactarla directamente.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default JoinDirectoryPage;
